/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from "react";
import { Tooltip, Box, Avatar, Skeleton } from "@mui/material";
import Badge, { BadgeProps } from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import AwardBadge from "../../assets/images/badge.svg";
import default_avatar from "../../assets/images/default_avatar.png";
import { useAppSelector } from "../../infra/hooks";
import { commonServices } from "../../api/services/commonServices";
interface IProfilePicProps {
  profilePic: {
    pic: string;
    award: any;
  };
}
const CustomCircleProfilePic = ({ profilePic }: IProfilePicProps) => {
  const [ showMsg, setShowMsg] = useState(false);
  const selector = useAppSelector((state) => state);
  const [cdnSignedpath, setcdnSignedpath] = useState("");
  const StyledBadge = styled(Badge)<BadgeProps>(() => ({
    "& .MuiBadge-badge": {
      right: 18,
      top: 20,
      border: "1px solid #FFB42B",
      backgroundColor: "black",
      borderRadius: "50%",
      width: "28px",
      height: "28px",
    },
  }));
  useEffect(() => {
    const user_id: any = selector.authSlice.user_id;
    const companyID: any = selector.authSlice.company_id;
    const Payload = {
      filepath: profilePic.pic,
      fullpath: true,
    };
    commonServices
      .getFilePath(companyID, user_id, Payload)
      .then((res: any) => {
        setcdnSignedpath(res);
      })
  }, [profilePic.pic]);

  const [loder, setLoder] = useState(false);
  useEffect(() => {
    if (cdnSignedpath == "") {
      setLoder(true);
    } else {
      setLoder(false);
    }
  }, [cdnSignedpath]);
  return profilePic.award != "" ? (
    <Tooltip
      title={profilePic.award}
      open={showMsg}
      placement="top"
      PopperProps={{
        sx: { top: "100px" },
      }}
    >
      <StyledBadge
        badgeContent={
          <img
            src={AwardBadge}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={() => setShowMsg(true)}
            onMouseLeave={() => setShowMsg(false)}
          />
        }
        color="primary"
      >
        <Avatar
          src={cdnSignedpath}
          style={{
            background: "transparent 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #00000029",
            border: "3px solid #ffffff",
            opacity: "1",
            height: "6.5em",
            width: "6.5em",
            borderRadius: "50%",
          }}
        />
      </StyledBadge>
    </Tooltip>
  ) : (
    <Box>
      {loder ? (
        <Skeleton
          variant="circular"
          style={{
            background: "transparent 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #00000029",
            border: "3px solid #ffffff",
            height: "6.5em",
            width: "6.5em",
            borderRadius: "50%",
          }}
        />
      ) : (
        <Avatar
          src={cdnSignedpath ? cdnSignedpath : default_avatar}
          style={{
            background: "transparent 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #00000029",
            border: "3px solid #ffffff",
            opacity: "1",
            height: cdnSignedpath ? "6.5em" : "4.563em",
            width: cdnSignedpath ? "6.5em" : "4.563em",
            borderRadius: "50%",
          }}
        />
      )}
    </Box>
  );
};
export default CustomCircleProfilePic;
